// @flow

import removeEstimateCaveat from '../../../Services/removeEstimateCaveat';
import type { RemoveEstimateCaveatParams } from '../../../types';

export default (params: RemoveEstimateCaveatParams) => async (dispatch: Function) => dispatch(removeEstimateCaveat(params))